import {Box, Skeleton} from '@chakra-ui/react';
import {FC} from 'react';

export const PromoSkeleton: FC = () => {
  return (
    <Box>
      <Skeleton w={['100px', '150px']} h={['100px', '150px']} mx="12px" borderRadius="16px" />
    </Box>
  );
};
